// extracted by mini-css-extract-plugin
export default {"errorAlert":"bcF54zpXCM5AsUMs_9P9"};